export const authActionTypes= {
    AUTH_START:"AUTH_START",
    AUTH_SUCCESS:"AUTH_SUCCESS",
    AUTH_ERROR:"AUTH_ERROR",
}